module.exports = __webpack_public_path__ + "img/main-elib.84efb493.jpg";